import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { Class, Course, Department, Faculty, fetchClass, fetchCourse, fetchDepartment, fetchFaculty, fetchGroups, fetchMyClasses, fetchSubject, Group, GroupFetchParams, GroupInfoFetchParams, Subject } from './api';

const defaultGroupsStaleTime = 1000 * 60 * 60; // 1 hour

export const groupsQueryOptions = (params: GroupFetchParams ) =>
    queryOptions<Group[]>({
        queryKey: ['groups', params],
        queryFn: () => fetchGroups(params),
        staleTime: defaultGroupsStaleTime,
    })

export function useGroups(params: GroupFetchParams) {
    return useQuery(groupsQueryOptions(params))
}

export function useGroupsSuspense(params: GroupFetchParams) {
    return useSuspenseQuery(groupsQueryOptions(params))
}

export function myClassesQueryOptions() {
    return queryOptions<Class[]>({
        queryKey: ['myClasses'],
        queryFn: () => fetchMyClasses(),
    })
}

export function useMyClasses() {
    return useQuery(myClassesQueryOptions())
}

export function useMyClassesSuspense() { 
    return useSuspenseQuery(myClassesQueryOptions()) 
}

export function facultyQueryOptions(params: GroupInfoFetchParams) {
    return queryOptions<Faculty>({
        queryKey: ['faculty', params],
        queryFn: () => fetchFaculty(params),
        staleTime: defaultGroupsStaleTime,
    })
}

export function useFaculty(params: GroupInfoFetchParams) {
    return useQuery(facultyQueryOptions(params))
}

export function useFacultySuspense(params: GroupInfoFetchParams) { 
    return useSuspenseQuery(facultyQueryOptions(params)) 
}

export function departmentQueryOptions(params: GroupInfoFetchParams) {
    return queryOptions<Department>({
        queryKey: ['department', params],
        queryFn: () => fetchDepartment(params),
        staleTime: defaultGroupsStaleTime,
    })
}

export function useDepartment(params: GroupInfoFetchParams) {
    return useQuery(departmentQueryOptions(params))
}

export function useDepartmentSuspense(params: GroupInfoFetchParams) { 
    return useSuspenseQuery(departmentQueryOptions(params)) 
}

export function subjectQueryOptions(params: GroupInfoFetchParams) {
    return queryOptions<Subject>({
        queryKey: ['subject', params],
        queryFn: () => fetchSubject(params),
        staleTime: defaultGroupsStaleTime,
    })
}

export function useSubject(params: GroupInfoFetchParams) {
    return useQuery(subjectQueryOptions(params))
}

export function useSubjectSuspense(params: GroupInfoFetchParams) { 
    return useSuspenseQuery(subjectQueryOptions(params)) 
}

export function courseQueryOptions(params: GroupInfoFetchParams) {
    return queryOptions<Course>({
        queryKey: ['course', params],
        queryFn: () => fetchCourse(params),
        staleTime: defaultGroupsStaleTime,
    })
}

export function useCourse(params: GroupInfoFetchParams) {
    return useQuery(courseQueryOptions(params))
}

export function useCourseSuspense(params: GroupInfoFetchParams) { 
    return useSuspenseQuery(courseQueryOptions(params)) 
}

export function classQueryOptions(params: GroupInfoFetchParams) {
    return queryOptions<Class>({
        queryKey: ['class', params],
        queryFn: () => fetchClass(params),
        staleTime: defaultGroupsStaleTime,
    })
}

export function useClass(params: GroupInfoFetchParams) {
    return useQuery(classQueryOptions(params))
}

export function useClassSuspense(params: GroupInfoFetchParams) { 
    return useSuspenseQuery(classQueryOptions(params)) 
}
